export default "__VITE_PUBLIC_ASSET__029c733e__"